import Vue from 'vue';

Vue.component('fnb-sync-index', () =>
    import(/* webpackChunkName: 'fnb-sync-index' */ './sync-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/sync/index.js